$(document).ready(function () {
  $('.accordion').on('click', '.accordion-toggle', function() {
    var $accordionPanel = $(this).closest('.accordion-panel');
    $accordionPanel.toggleClass('expanded');
    $accordionPanel.find('.accordion-text').slideToggle(300);

    // TOGGLE ARIA-EXPANDED FOR ADA
    $accordionPanel.attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true';
    });

  });

});
